"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserDetailsContracts = exports.mutateUserDetailsContract = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userDetailsContractsQuery = (0, graphql_tag_1.default) `
query UserDetailsContracts($workspaceId: ID!, $userId: ID!) {
  role(workspace: $workspaceId, user: $userId) {
    contracts {
      id
      contractId
      type
      positions {
        created
        positionId
        productionForecast
        skill
      }
      period {
        end
        start
      }
      default
      options
      compiled {
        options
        rules
      }
    }
  }
}`;
const userDetailsContractMutation = (0, graphql_tag_1.default) `
  mutation RoleContractUpdate($workspaceId: ID!, $userId: ID!, $id: ID!, $data: RoleContractInput!) {
    roleContractUpdate(workspace: $workspaceId, user: $userId, id: $id, data: $data) {
      compiled {
        options
        rules
      }
      contractId
      default
      id
      options
      period {
        end
        start
      }
      positions {
        created
        positionId
        productionForecast
        skill
      }
      type
    }
  }
  `;
const mutateUserDetailsContract = async ({ workspaceId, userId, id, data, }) => {
    const { data: mutateData, errors } = await (0, apollo_1.mutate)(userDetailsContractMutation, {
        variables: {
            workspaceId, userId, id, data,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return mutateData?.roleContractUpdate;
};
exports.mutateUserDetailsContract = mutateUserDetailsContract;
const requestUserDetailsContracts = async ({ workspaceId, userId, }) => {
    const { data, errors } = await (0, apollo_1.query)(userDetailsContractsQuery, {
        variables: {
            workspaceId, userId,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role;
};
exports.requestUserDetailsContracts = requestUserDetailsContracts;
